// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"50517271","453":"939b479a","667":"6f4db1f9"}[chunkId] + ".chunk.js";
};